module.exports = __webpack_public_path__ + "media/images/moxtra-d8cadd2d068350daef835f13bf778a79.svg";